<template>
  <div class="modal-uploaded-view-wrap">
    <!-- MAIN -->
    <div class="invoice-wrap-bg">
      <div class="invoice-wrap">
        <div class="uploaded-left is-shadow-box">
          <div class="uploaded-details" style="padding: 0 1rem;">
            <div class="uploaded-details--section">
              <!-- Number / name -->
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Correction Name') }}</h4>
                <div class="big-item">
                  {{ invoice.correction.name }}
                </div>
              </div>
              <!-- Date / period -->
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Period') }}</h4>
                <div class="big-item">
                  {{ invoice.correction.timeframe }}
                </div>
              </div>
              <!-- Customer -->
              <div v-if="!invoice.correction.no_customer" class="uploaded-details--section__item">
                <h4>{{ $gettext('Customer') }}</h4>
                <div class="big-item">
                  {{ invoice.recipient_customer.name }}
                </div>
              </div>
              <!-- Project -->
              <div v-if="invoice.project" class="uploaded-details--section__item">
                <h4>{{ $gettext('Project') }}</h4>
                <div class="big-item">
                  {{ invoice.project.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-lines-wrap">
            <InvoiceLinesPreview 
              ref="invoice-lines-preview"
              :invoice="invoice"
              :excludeTableFields="['quantity', 'description']"
            />
          </div>
        </div> <!-- end uploaded-left -->

        <div class="uploaded-right">
          <div class="uploaded-details">
            <!-- Files -->
            <div v-if="attachedDocuments && attachedDocuments.length > 0" class="uploaded-details--section full-w">
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Files') }}</h4>
                <div class="uploaded-details--section__item">
                  <div v-for="file in attachedDocuments" :key="file.id" class="d-flex">
                    <div class="mr-1">{{ file.title }}</div>
                    <div>
                      <GekkoButton 
                        @click="downloadDocument(file)"
                        icon="fa-solid fa-download"
                        variant="link" 
                        class="text-info p-0"
                        size="sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Message -->
            <div v-if="invoice.message && invoice.message != ''" class="uploaded-details--section full-w">
              <div class="uploaded-details--section__item">
                <h4>{{ $gettext('Message') }}</h4>
                <div style="font-size: 1rem;">
                  {{ invoice.message }}
                </div>
              </div>
            </div>
          </div>
        </div>  <!-- end uploaded-left -->

      </div> <!-- end invoice-wrap -->
    </div> <!-- end invoice-wrap-bg -->
  </div> <!-- end modal-uploaded-view-wrap -->
</template>
<script>
import { mapGetters } from "vuex";

import invoices from "@/mixins/invoices";

import GekkoButton from "@/components/GekkoButton"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import InvoiceLinesPreview from "@/components/invoices/ui/InvoiceLinesPreview"

export default {
  name: "CorrectionView",
  mixins: [invoices],
  components: {
    GekkoButton,
    LoadingSpinner,
    InvoiceLinesPreview
  },
  data () {
    return {
      invoiceId: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
      correctionFiles: 'invoices/getCorrectionFiles'
    }),
    attachedDocuments () {
      return this.correctionFiles
    },
    isEUR () {
      return (this.invoice.currency === 'EUR')
    },
    totalAmountEUR () {
      return this.$options.filters.currency(this.invoice.total_amount, 'EUR', 2)
    },
    totalAmountCurrency () {
      return this.$options.filters.currency(this.invoice.currency_total_amount, this.invoice.currency, 2)
    },
    totalAmount () {
      let total_amount = 0

      if (this.isEUR) {
        total_amount = this.totalAmountEUR
      } else {
        if (this.invoice.total_amount && this.invoice.total_amount > 0) {
          total_amount = this.totalAmountCurrency + ' <span>(' + this.totalAmountEUR + ')</span>'
        } else {
          total_amount = this.totalAmountCurrency
        }
      }

      return total_amount
    }
  },
  created () {
    this.invoiceId = this.$route.params['invoiceId']
    if (this.invoiceId) {
      this.setupData()
    }
  },
  methods: {
    setupData () {
      if (this.invoice) {
        console.log('view this.invoice correction', this.invoice)
        this.$emit('display-buttons', 'view')
      } else {
        console.log('Invoice is not set')
      }
      this.loading = false
    }
  }
}
</script>
<style scoped lang="scss">
  .modal-uploaded-view-wrap {
    height: 100%;
  }

  .mastermodal-view-wrap {

  }
</style>

<style lang="scss">
  
</style>